<template>
  <div>
    <div class="e-cookie-consent bg-white shadow-sm" v-if="visible">
      <div class="e-cookie-consent__text">
        {{ $t('cookieConsent.text') }}
      </div>
      <div class="e-cookie-consent__actions">
        <button type="button" class="btn btn-outline-secondary btn-sm mr-2" @click="openOptions">
          {{ $t('cookieConsent.moreOptions') }}
        </button>
        <button type="button" class="btn btn-success btn-sm" @click="acceptAll">
          {{ $t('cookieConsent.accept') }}
        </button>
      </div>
    </div>

    <div class="e-card-backdrop" v-if="showOptions">
      <div class="row e-modal-row justify-content-center align-items-start">
        <div class="e-modal-card col-10 col-lg-6 bg-white shadow-sm e-rounding p-0">
          <div class="card-header e-user__header">
            <span>{{ $t('cookieConsent.moreOptions') }}</span>
            <i @click="closeOptions" class="fas fa-times e-modal-close-icon"></i>
          </div>
          <div class="card-body py-4 px-4">
            <div class="custom-control custom-switch mb-3">
              <input type="checkbox" class="custom-control-input" role="switch" id="cookieConsentAnalytics" v-model="analyticsEnabled">
              <label class="custom-control-label" for="cookieConsentAnalytics">
                {{ $t('cookieConsent.analytics') }}
              </label>
            </div>
            <div class="custom-control custom-switch mb-4">
              <input type="checkbox" class="custom-control-input" role="switch" id="cookieConsentAds" v-model="adsEnabled">
              <label class="custom-control-label" for="cookieConsentAds">
                {{ $t('cookieConsent.ads') }}
              </label>
            </div>
            <div class="text-right">
              <button type="button" class="btn btn-success btn-sm" @click="saveOptions">
                {{ $t('cookieConsent.save') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieConsent',

  data: function () {
    return {
      visible: false,
      showOptions: false,
      analyticsEnabled: true,
      adsEnabled: true
    }
  },

  mounted: function () {
    if (!localStorage.cookieConsent) {
      this.visible = true
    }
  },

  methods: {
    openOptions: function () {
      this.showOptions = true
    },

    closeOptions: function () {
      this.showOptions = false
    },

    acceptAll: function () {
      this.saveConsent('granted', 'granted')
    },

    saveOptions: function () {
      this.saveConsent(this.analyticsEnabled ? 'granted' : 'denied', this.adsEnabled ? 'granted' : 'denied')
    },

    saveConsent: function (analyticsState, adsState) {
      this.updateConsent(analyticsState, adsState)
      localStorage.cookieConsent = JSON.stringify({ analytics: analyticsState, ads: adsState })
      this.showOptions = false
      this.visible = false
    },

    updateConsent: function (analyticsState, adsState) {
      if (typeof window.gtag === 'function') {
        window.gtag('consent', 'update', {
          ad_storage: adsState,
          ad_user_data: adsState,
          ad_personalization: adsState,
          analytics_storage: analyticsState
        })
      }
    }
  }
}
</script>

<style scoped>
.e-cookie-consent {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1050;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid rgba(0, 0, 0, .1);
}

.e-cookie-consent__text {
  flex: 1 1 300px;
  font-size: .9rem;
}

.e-cookie-consent__actions {
  flex: 0 0 auto;
  white-space: nowrap;
}
</style>
